export default __webpack_public_path__ + "static/media/exam-review-bg.64dd9b25.svg";